// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PP","articleImagesWrap":"QP","articleImage":"RP","singleImage":"SP"};